import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import styles from './DeleteApprover.module.scss'

interface IProps {
  onDeleteApprover: () => void
  disabled: boolean
}

export const DeleteApprover = ({ onDeleteApprover, disabled }: IProps) => {
  return (
    <Button color="danger" onClick={onDeleteApprover} disabled={disabled} className={styles.btn}>
      <Translation text={'jbp-commitment-delete'} span actionsInside />
    </Button>
  )
}
